/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class vendorindex extends IceEntity {
  vendor_index_key: string = "";
  trans_account: string = "";
  organization_name: string = "";
  city: string = "";
  state_id: string = "";
  postal_code: string = "";
  identification_code1: string = "";
  identification_code2: string = "";
  identification_code3: string = "";
  additional_name: string = "";

  constructor() {
    super();
  }

  gettablename(): string {
    return "VENDOR_INDEX";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "CONS") return true;
    else if (ColumnName == "ADS") return true;
    else if (ColumnName == "ENTS") return true;
    else if (ColumnName == "IDS") return true;
    else if (ColumnName == "TYPES") return true;
    else if (ColumnName == "CONNPARAMS") return true;
    else if (ColumnName == "TYPEREFS") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "CONS") return "CONTACT";
    else if (ColumnName == "ADS") return "ADDRESS";
    else if (ColumnName == "ENTS") return "ENTITY";
    else if (ColumnName == "IDS") return "IDENTIFICATION";
    else if (ColumnName == "TYPES") return "TRANS_TYPE";
    else if (ColumnName == "CONNPARAMS") return "CONNECTION_PARAMETERS";
    else if (ColumnName == "TYPEREFS") return "TRANS_TYPE_REFERENCE";

    return null;
  }

  getdisplayname(organization: boolean): string {
    return this.organization_name;
  }
}
